import React from 'react';

import PropTypes from 'prop-types';

import './ThemedSwitch.sass';

export const ThemedSwitch = ({ checked, onChange }) => (
  <label className="themed-switch__switch" htmlFor="themed-switch">
    <input type="checkbox" id="themed-switch" checked={checked} onChange={onChange} />
    <span className="themed-switch__switch-slider" />
  </label>
);

ThemedSwitch.propTypes = {
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
};
